import {
  DisplayAs,
  InputElementFragment,
} from "__generated__/graphqlUnauthenticated";
import { hideTypes } from "./PreviewFormUI";
import * as Yup from "yup";

// Field types that use array values (multi-select, checkboxes, tags, etc.)
const selectFieldTypes = [
  DisplayAs.MultiOptionalValue,
  DisplayAs.Checkbox,
  DisplayAs.RadioButton,
  DisplayAs.OptionalValue,
];

export const generateValidationSchema = (
  elements: InputElementFragment[],
  ff_update_form_validation: boolean | undefined,
) => {
  const schemaObject = {};
  elements.forEach((element) => {
    if (
      element.__typename === "InputElement" &&
      element.required &&
      !hideTypes.includes(element.displayAs || "") &&
      !element.hidden
    ) {
      const fieldName = element.field.toLowerCase();
      const elementId = element.id || "";

      if (
        element.displayAs &&
        selectFieldTypes.includes(element.displayAs) &&
        ff_update_form_validation
      ) {
        schemaObject[elementId] = Yup.string().test(
          "has-selection",
          `Please select at least one option for ${fieldName}`,
          (value) => {
            if (!value) return false;
            try {
              const parsed = JSON.parse(value);
              if (Array.isArray(parsed)) {
                return parsed.length > 0;
              } else if (parsed && typeof parsed === "object") {
                return "id" in parsed && "value" in parsed;
              }
              return false;
            } catch {
              return false;
            }
          },
        );
      } else {
        // For regular fields, use string validation
        schemaObject[elementId] = Yup.string().required(
          `Please enter ${fieldName}`,
        );
      }
    }
  });

  return Yup.object().shape(schemaObject);
};
